import { ColorTypes } from "pdf-lib";

export var palette = [
    "#eb973e", 
    "#5db157",
    "#00749f",
    "#8063a4",
    "#9f68a5",
    "#898989",
    "#a07d58",
    "#968677",
    "#0071b6",
    "#55ccc6",
]
export function getColor(index: number): string {
    const i = index % palette.length;
    return palette[i];
}

export function hexToRGB(hex: string) {
	hex = hex.replace('#', '');
	if (hex.length === 3) {
		hex = hex
			.split('')
			.map((char) => char + char)
			.join('');
	}
	// Parse hex to RGB
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);
	return { r, g, b };
};

export function hexToPdfRGB(hex: string) {
	const rgb = hexToRGB(hex);
	return {
		type: ColorTypes.RGB,
		red: rgb.r / 255,
		green: rgb.g / 255,
		blue: rgb.b / 255,
	} as any;
}